import React from "react";
import { StateToInt, TournamentEvent } from "../../../types";
import { StateBadge } from "../StateBadge";
import { RankingTable } from "../RankingTable";
import { Button } from "../Button";

interface EventGeneralPanelProps {
  event: TournamentEvent;
  canManage: boolean;
  canGenerateResultsAutomatically: boolean;
  generatingRanking: boolean;
  hasMatches: boolean;
  exportingExcel: boolean;
  exportingPdf: boolean;
  onEditInfo: () => void;
  onEditRanking: () => void;
  onGenerateRanking: () => Promise<void>;
  onExportExcel: () => void;
  onExportPdf: () => Promise<void>;
}

export const EventGeneralPanel: React.FC<EventGeneralPanelProps> = ({
  event,
  canManage,
  canGenerateResultsAutomatically,
  generatingRanking,
  hasMatches,
  exportingExcel,
  exportingPdf,
  onEditInfo,
  onEditRanking,
  onGenerateRanking,
  onExportExcel,
  onExportPdf,
}) => {
  let locationName = "N/D";
  if (event.location) {
    locationName = event.location.name;
    if (event.location.address) {
      locationName += `, ${event.location.address}`;
    }
  }

  return (
    <>
      <div className="bg-white border border-gray-300 rounded shadow-sm p-6 mt-6">
        <div className="flex items-center justify-between border-b mb-2">
          <h2 className="text-lg font-semibold pb-2">Info generali</h2>
          {canManage && (
            <Button size="sm" variant="warning" className="mb-3" onClick={onEditInfo}>
              Modifica
            </Button>
          )}
        </div>
        <dl className="space-y-2">
          <div className="flex justify-between">
            <dt className="font-medium">Stato:</dt>
            <dd>
              <StateBadge stato={event.state} size="xs" />
            </dd>
          </div>
          <div className="flex justify-between">
            <dt className="font-medium">Data:</dt>
            <dd>{event.date || "N/D"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="font-medium">Orario:</dt>
            <dd>{event.time || "N/D"}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="font-medium">Punteggio massimo:</dt>
            <dd>{event.tournament_points}</dd>
          </div>
          <div className="flex justify-between">
            <dt className="font-medium">Luogo:</dt>
            <dd>{locationName}</dd>
          </div>
        </dl>
      </div>

      <div className="bg-white border border-gray-300 rounded shadow-sm p-6 mt-6">
        <div className="flex items-center justify-between border-b mb-2">
          <h2 className="text-lg font-semibold pb-2">Classifica</h2>
          {canManage && StateToInt[event.state] >= StateToInt.confermato && (
            <Button
              size="sm"
              variant={event.results.length > 0 ? "warning" : "primary"}
              onClick={onEditRanking}
            >
              {event.results.length > 0 ? "Modifica" : "Inserisci"}
            </Button>
          )}
        </div>
        {event.results.length > 0 ? (
          <RankingTable type="tournament" data={event.results} />
        ) : (
          <p className="p-4 text-center text-red-500">
            {canManage && canGenerateResultsAutomatically ? (
              <Button
                size="sm"
                variant="success"
                onClick={onGenerateRanking}
                disabled={generatingRanking}
              >
                {generatingRanking ? "Generazione..." : "Genera automaticamente"}
              </Button>
            ) : (
              event.state === "concluso"
                ? "La classifica non é ancora stata inserita"
                : "L'evento non é ancora concluso"
            )}
          </p>
        )}
      </div>

      {hasMatches && (
        <div className="bg-white border border-gray-300 rounded shadow-sm p-6 mt-6">
          <div className="border-b mb-4">
            <h2 className="text-lg font-semibold pb-2">Esportazione calendario</h2>
          </div>
          <div className="flex items-center justify-between gap-3 ">
            <Button size="sm" variant="success" isOutlined={true} onClick={onExportExcel} disabled={exportingExcel}>
              {exportingExcel ? "Esportazione Excel..." : "Export Excel"}
            </Button>
            <Button size="sm" variant="destructive" isOutlined={true} onClick={onExportPdf} disabled={exportingPdf}>
              {exportingPdf ? "Esportazione PDF..." : "Export PDF"}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
